import shortid from "shortid";
import {
  Button,
  Grid,
  TextField,
  IconButton,
  Tooltip,
  Typography,
  Divider,
  Box,
} from "../../../../../components";
import { useState } from "react";
import { notification } from "../../../../../services";

export function AcessoriosAtivoConfiguracao({
  acessoriosAtivo,
  setAcessoriosAtivo,
}) {
  const [emModoEdicao, setEmModoEdicao] = useState(false);
  const [acessorioAtual, setAcessorioAtual] = useState({
    id: shortid.generate(),
    descricao: "",
  });

  const handleRemover = (id) => {
    setAcessoriosAtivo((prev) => prev.filter((a) => a.id !== id));
  };

  const handleEditar = (id) => {
    const acessorio = acessoriosAtivo.find((a) => a.id === id);
    setAcessorioAtual(acessorio);
    setEmModoEdicao(true);
  };

  const handleCancelar = () => {
    setAcessorioAtual({ id: shortid.generate(), descricao: "" });
    setEmModoEdicao(false);
  };

  const handleSubmit = () => {
    if (!acessorioAtual.descricao.trim()) return;
    if (
      acessoriosAtivo.some(
        (a) =>
          a.descricao.toLowerCase() ===
            acessorioAtual.descricao.toLowerCase() &&
          a.id !== acessorioAtual.id,
      )
    ) {
      return notification.alertaGenericos(
        "Já existe um acessório com essa descrição.",
      );
    }
    if (emModoEdicao) {
      setAcessoriosAtivo((prev) =>
        prev.map((a) => (a.id === acessorioAtual.id ? acessorioAtual : a)),
      );
    } else {
      setAcessoriosAtivo((prev) => [...prev, acessorioAtual]);
    }
    setAcessorioAtual({ id: shortid.generate(), descricao: "" });
    setEmModoEdicao(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
    if (e.key === "Escape") handleCancelar();
  };

  return (
    <div className="my-3">
      <div className="d-flex align-items-center gap-2 mb-3">
        <i
          className="ph-bold ph-package"
          style={{ fontSize: 16, color: "#555" }}
        />
        <Typography
          variant="subtitle2"
          style={{
            fontSize: 12,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 0.8,
            color: "#444",
            flex: 1,
          }}
        >
          Acessórios do Ativo
        </Typography>
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            backgroundColor: "#e0e0e0",
            color: "#555",
            borderRadius: 10,
            padding: "1px 8px",
            minWidth: 22,
            textAlign: "center",
          }}
        >
          {acessoriosAtivo.length}
        </span>
      </div>
      <div className="d-flex gap-2 mb-3">
        <TextField
          size="small"
          fullWidth
          placeholder={
            emModoEdicao ? "Editar acessório..." : "Novo acessório..."
          }
          value={acessorioAtual.descricao}
          onChange={(e) => {
            const value = e.target.value;
            if (emModoEdicao) {
              setAcessorioAtual({ ...acessorioAtual, descricao: value });
            } else {
              setAcessorioAtual({ id: shortid.generate(), descricao: value });
            }
          }}
          onKeyDown={handleKeyDown}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#fafafa",
            },
          }}
        />
        <Tooltip
          title={emModoEdicao ? "Salvar edição (Enter)" : "Adicionar (Enter)"}
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleSubmit}
            style={{
              minWidth: 38,
              padding: 10,
              borderRadius: 8,
            }}
          >
            <i
              className={`ph-bold ${emModoEdicao ? "ph-check" : "ph-plus"}`}
              style={{ color: "white", fontSize: 15 }}
            />
          </Button>
        </Tooltip>
        {emModoEdicao && (
          <Tooltip title="Cancelar (Esc)">
            <Button
              variant="outlined"
              color="padrao"
              disableElevation
              onClick={handleCancelar}
              style={{
                minWidth: 38,
                paddingInline: 10,
                borderRadius: 8,
                alignSelf: "stretch",
              }}
            >
              <i className="ph-bold ph-x" style={{ fontSize: 15 }} />
            </Button>
          </Tooltip>
        )}
      </div>

      <Divider className="mb-3" />

      {!acessoriosAtivo.length ? (
        <Box className="d-flex flex-column align-items-center justify-content-center gap-2 py-4">
          <i
            className="ph-bold ph-package"
            style={{ fontSize: 28, color: "#ccc" }}
          />
          <Typography
            variant="body2"
            className="text-muted"
            style={{ fontSize: 12 }}
          >
            Nenhum acessório cadastrado.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={1}>
          {acessoriosAtivo.map((acessorio) => (
            <Grid item xs={6} key={acessorio.id}>
              <Box
                className="d-flex align-items-center justify-content-between px-3 py-2 rounded"
                style={{
                  border: "1px solid #eeeeee",
                  backgroundColor: "#ffffff",
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    fontSize: 13,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                >
                  {acessorio.descricao}
                </Typography>
                <Box className="d-flex gap-1 ms-2">
                  <Tooltip title="Editar">
                    <IconButton
                      size="small"
                      onClick={() => handleEditar(acessorio.id)}
                      style={{ padding: 4 }}
                    >
                      <i
                        className="ph-fill ph-pencil"
                        style={{ fontSize: 14 }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Remover">
                    <IconButton
                      size="small"
                      onClick={() => handleRemover(acessorio.id)}
                      style={{ padding: 4 }}
                    >
                      <i
                        className="ph-fill ph-trash"
                        style={{ fontSize: 14 }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
}
